"use client"

import { useCallback } from "react"
import { hasCookie, deleteCookie } from "cookies-next/client"
import { makeURL } from "@nauverse/make-url"
import { showNotification } from "@/lib/notifications"
import { LAUNCHER_APP_PATH } from "@/config/defaults"
import { Cookies } from "@/config/enums"
import { config } from "@/config"

export function useLogout() {
  const performLogout = useCallback(async () => {
    try {
      // Delete app data cookies for both production and localhost domains
      if (
        hasCookie(Cookies.Enum.appData, {
          path: "/",
          domain: ".ring.io",
        })
      ) {
        deleteCookie(Cookies.Enum.appData, {
          path: "/",
          domain: ".ring.io",
        })
      }

      if (
        hasCookie(Cookies.Enum.appData, {
          path: "/",
          domain: ".localhost",
        })
      ) {
        deleteCookie(Cookies.Enum.appData, {
          path: "/",
          domain: ".localhost",
        })
      }

      // Build logout URL with proper parameters
      const logoutURL = makeURL(config.environment.api.launcherURL ?? config.environment.api.baseURL, `${LAUNCHER_APP_PATH}/logout/web`, {
        config: {
          trailingSlash: "remove",
        },
        params: {
          resource: "next",
          origin: typeof window !== "undefined" ? window.location.origin : "",
        },
      })

      // Redirect to logout URL
      window.location.replace(logoutURL)
    } catch (err) {
      showNotification({
        type: "error",
        title: "Error while logging out",
        message: (err as any)?.message ?? "Try again in a few seconds or reach your administrator for help.",
      })
    }
  }, [])

  return { performLogout }
}
